import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Api from "../../component/Api";
import useAuth from "../../component/useAuth";
import "react-toastify/dist/ReactToastify.css";

export default function CondonationPayment() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const [loading, setLoading] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("false");
  const [amount, setAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");

  // Get payment values from localStorage
  const txnid = localStorage.getItem("transaction_id");
  const semester = localStorage.getItem("semester");
  const accountid = localStorage.getItem("accountid");

  const { http } = Api();

  // Countdown redirect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    } else {
      navigate("/condonation");
    }
    setLoading(true);
  }, [countdown, navigate]);

  // Auth check
  const isAuth = useAuth();
  useEffect(() => {
    if (isAuth === false) navigate("/");
  }, [isAuth, navigate]);

  // Payment validation & status
  useEffect(() => {
    http
      .post(`/Student/StudentCondonationPaymentReceipt`, {
        txnid: localStorage.getItem("transaction_id"),
        semester: localStorage.getItem("semester"),
      })
      .then((response) => {
        if (response.data.Status === "SUCCESS") {
          setPaymentMsg("success");
          setAmount(response.data.amt);
          setTransactionId(response.data.transId);
        } else if (
          response.data.Status === "failure" ||
          response.data.Status === "Cancelled" ||
          response.data.Status === "FAILED"
        ) {
          setPaymentMsg("failure");
        } else if (response.data.Status === "PENDING") {
          setPaymentMsg("pending");
        } else {
          setPaymentMsg("unknown");
          toast.warn("Unknown payment status received");
        }
      })
      .catch((error) => {
        toast.error("Error during payment receipt request");
        setPaymentMsg("failure");
      });
  }, []);

  useEffect(() => {
    const generatePdf = async () => {
      try {
        const response = await http.post(
          "/Student/paymentCondonationReceiptPdf",
          {
            txnid,
            semester,
          },
          { responseType: "blob" }
        );

        if (response?.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "CondonationPaymentReceipt.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success("PDF generated successfully!");
        }
      } catch (error) {
        toast.error("Error generating PDF receipt");
      }
    };

    if (paymentMsg === "success") generatePdf();
  }, [paymentMsg]);

  return (
    <>
      <ToastContainer />
      {paymentMsg === "success" ? (
        <div className="success-page">
          <body>
            <div className="container">
              <div className="printer-top"></div>
              <div className="paper-container">
                <div className="paper">
                  <div className="success-icon">
                    <span>&#10004;</span>
                  </div>
                  <div className="success-title">₹{amount}</div>
                  <div className="success-title">Payment Complete</div>
                  <div className="success-description">
                    Thank you for completing the payment! Check the Receipt for
                    more details.
                  </div>
                  <div className="order-details">
                    <div className="order-number-label">Transaction ID</div>
                    <div className="order-number">{transactionId}</div>
                  </div>
                  <div className="warning">
                    Please do not go back or refresh this page.
                  </div>

                  {!loading ? (
                    <div className="countdown">
                      Redirecting in <span>{countdown}</span> seconds...
                    </div>
                  ) : (
                    <div className="text-center">
                      <Link to="/condonation">
                        Click here if you are not redirected
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </body>
        </div>
      ) : paymentMsg === "failure" ? (
        <div className="failure-page">
          <body>
            <div className="container">
              <div className="printer-top"></div>
              <div className="paper-container">
                <div className="paper">
                  <div className="failure-icon">
                    <span>&#10008;</span>
                  </div>
                  <div className="failure-title">Payment Failed</div>
                  <div className="failure-description">
                    We're sorry, but your payment could not be processed. Please
                    check your payment details and try again.
                  </div>
                  <div className="transaction-details">
                    <div className="retry-message">Please Try Again</div>
                  </div>
                  <div className="warning">
                    Please do not go back or refresh this page.
                  </div>

                  {!loading ? (
                    <div className="countdown">
                      Redirecting in <span>{countdown}</span> seconds...
                    </div>
                  ) : (
                    <div className="text-center">
                      <Link to="/condonation">
                        Click here if you are not redirected
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </body>
        </div>
      ) : (
        paymentMsg === "pending" && (
          <div className="pending-page">
            <body>
              <div className="container">
                <div className="printer-top"></div>
                <div className="paper-container">
                  <div className="paper">
                    <div className="pending-icon">
                      <span>&#8987;</span>
                    </div>
                    <div className="pending-title">Payment Pending</div>
                    <div className="pending-description">
                      <strong>
                        This may take a few moments. Check the Receipt for more
                        details.
                      </strong>
                    </div>
                    <div className="transaction-details">
                      <div className="status-message">Processing...</div>
                    </div>

                    {!loading ? (
                      <div className="countdown">
                        Redirecting in <span>{countdown}</span> seconds...
                      </div>
                    ) : (
                      <div className="text-center">
                        <Link to="/condonation">
                          Click here if you are not redirected
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </body>
          </div>
        )
      )}
    </>
  );
}
